(function() {
    const cfg = {
        name: '_mp_params',
        minutes: 30
    };

    const pTrack = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic', 'gclid', 'gbraid', 'wbraid'];

    function getCookie(name) {
        const val = `; ${document.cookie}`;
        const parts = val.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    function setCookie(name, val, minutes) {
        let exp = "";
        if (minutes) {
            const d = new Date();
            d.setTime(d.getTime() + (minutes * 60 * 1000));
            exp = "; expires=" + d.toUTCString();
        }
        document.cookie = `${name}=${JSON.stringify(val) || ""}${exp}; path=/; SameSite=Lax`;
    }

    function getConsent() {
        const c = getCookie('CookieConsent');
        const defaults = { necessary: 'denied', preferences: 'denied', statistics: 'denied', marketing: 'denied' };
        if (!c) return defaults;
        try {
            return decodeURIComponent(c).replace(/^{|}$/g, '').split(',').reduce((cons, pair) => {
                const [key, val] = pair.split(':');
                const k = key.trim();
                if (k in cons) {
                    cons[k] = val.trim() === 'true' ? 'granted' : 'denied';
                }
                return cons;
            }, { ...defaults });
        } catch (e) {
            return defaults;
        }
    }

    function getData() {
        const oldD = (() => {
            try { return JSON.parse(getCookie(cfg.name)) || {}; } catch (e) { return {}; }
        })();
        
        let newD = { ...oldD };
        let hasChanged = false;

        if (!oldD.mp_landing_page) {
            const params = new URLSearchParams(window.location.search);
            
            pTrack.forEach(p => {
                const paramValue = params.get(p);
                if (params.has(p)) {
                    newD[`mp_${p}`] = paramValue;
                }
            });
            
            newD.mp_landing_page = window.location.href;
            newD.mp_referrer = document.referrer || '';
            
            hasChanged = true;
        }

        const gaCookieExists = getCookie('_ga') !== null;
        if (newD.mp_cookie_ga !== gaCookieExists) {
            newD.mp_cookie_ga = gaCookieExists;
            hasChanged = true;
        }

        const consents = getConsent();
        const adStorage = consents.marketing === 'granted' ? '1' : '0';
        const analyticsStorage = consents.statistics === 'granted' ? '1' : '0';
        const gcs = `G1${adStorage}${analyticsStorage}`;

        if (newD.mp_gcs !== gcs) {
            newD.mp_gcs = gcs;
            hasChanged = true;
        }

        const fbp = getCookie('_fbp');
        if (newD.mp_fbp !== fbp) {
            newD.mp_fbp = fbp;
            hasChanged = true;
        }
        
        const fbc = getCookie('_fbc');
        if (newD.mp_fbc !== fbc) {
            newD.mp_fbc = fbc;
            hasChanged = true;
        }
        
        if (hasChanged) {
            setCookie(cfg.name, newD, cfg.minutes);
        }

        return newD;
    }

    async function updateCart(attrs) {
        try {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs })
            });
        } catch (e) {}
    }

    const data = getData();
    updateCart(data);
})();
